module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "20px 0 0 50px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('span', [_vm._v("到店有礼：")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#138cdd",
      "inactive-color": "#999999",
      "change": _vm.handleSwitch()
    },
    model: {
      value: (_vm.yyisOpen),
      callback: function($$v) {
        _vm.yyisOpen = $$v
      },
      expression: "yyisOpen"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "75px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30%",
      "display": "block"
    },
    attrs: {
      "placeholder": "输入礼品名称，不超过10个汉字",
      "maxlength": "10"
    },
    model: {
      value: (_vm.ActivityContent),
      callback: function($$v) {
        _vm.ActivityContent = $$v
      },
      expression: "ActivityContent"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload",
    staticStyle: {
      "display": "block",
      "margin-top": "15px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeCoverOfDecoration
    }
  }, [(_vm.coverImageUrlOne) ? _c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.coverImageUrlOne
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888",
      "margin-top": "10px"
    }
  }, [_vm._v("请上传礼品图片建议尺寸：1比1 ，支持的图片格式，jpg、png。")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.emit()
      }
    }
  }, [_vm._v("确定")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59f10271!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeManagement/ddyl.vue
// module id = 1694
// module chunks = 3